import { render, staticRenderFns } from "./Flying_panel.vue?vue&type=template&id=f139aada"
import script from "./Flying_panel.vue?vue&type=script&lang=ts"
export * from "./Flying_panel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports